import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-request-group',
  templateUrl: './request-group.component.html',
  styleUrls: ['./request-group.component.scss'],
})
export class RequestGroupComponent implements OnInit {
  @Input() data: any = undefined;
  public fieldFormsDetail = undefined;
  private _domainId = environment.domainId;

  constructor(
    private formSv: FormServices,
    private route: ActivatedRoute,
    private httpSv: HttpService
  ) {}

  ngOnInit() {
    this.getForms();
  }

  async getForms() {
    try {
      let detailForm: any[] = await this.formSv.getForm(
        'specialRequests',
        this._domainId
      );
      detailForm = detailForm.filter((x) => x.fieldName !== 'description');
      detailForm.forEach((x) => (x.disable = 1));
      this.fieldFormsDetail = detailForm;

      setTimeout(async () => {
        const specialRequestId = this.route.snapshot.queryParamMap.get('id');
        if (specialRequestId) {
          const response = await this.httpSv.itemIndex(
            'specialRequests',
            specialRequestId,
            {},
            'show/'
          );
          this.data = response.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }
}
